/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Board = {
  type: 'Enum',
} as const;
